export enum LadingCodePrintStatus {
    NotPrint = 1,
    Printed = 2
}